import { DateUtility } from '../../utilities/date.utility';
import * as Enumerable from 'linq';
import { ActivityLocation } from './activity.location';


export enum DailyLogDateType {
    Day = 'day',
    Week = 'week'
}

export interface DailyLogRequest {
    date: Date;
    groupBy: DailyLogGroupBy;
    jobId: string;
    dateType: DailyLogDateType;
}

export interface DailyLogResponse {
    logs: ActivityLocationGroup[];
    date: Date;
}

export enum DailyLogGroupBy {
    Date = 'Date',
    Resource = 'Resource'
}

export interface ActivityLocationGroup extends ActivityLocation {
    path: string[];
}


export function toDailyLogGroup(locations: ActivityLocation[], groupBy: DailyLogGroupBy, dateFormat: string): ActivityLocationGroup[] {

    const groupItems = Enumerable
        .from(locations)
        .select(x => {
            if (groupBy === DailyLogGroupBy.Date) {

                const onlyDate = DateUtility.getDateTime(x.date).toFormat(dateFormat);

                return onlyDate;
            }

            return `${x.contact?._id}::${x.contact?.name}`;
        })
        .distinct(e => e)
        .select(x => {


            return {
                _id: x,
                path: [x]
            } as any;
        })
        .toArray();

    const items = Enumerable
        .from(locations)
        .groupBy(x => {
            if (groupBy === DailyLogGroupBy.Date) {

                const onlyDate = DateUtility.getDateTime(x.date).toFormat(dateFormat);

                return onlyDate;
            }

            return `${x.contact?._id}::${x.contact?.name}`;
        })
        .selectMany(e => {

            const items = Enumerable.from(e.getSource())
                .select(i => {

                    return {
                        ...i,
                        path: [e.key(), i._id]
                    }
                });

            return items;
        })
        .toArray();

    return [...groupItems, ...items];
}